import { useState } from "react"
import { HxMapGroup } from "../../../../Comps/HxMap/HxMapGroup"
import { HexMap } from "../../../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../../../Data/HexMap/HexMapModifier"
import { Key } from "../../../../Data/HexMap/Key"
import { All } from "../../../../Util/Constants/Quantities"
import { Music } from "../../../../Util/Music/Music"
import { TransformTranslate } from "../../../../Util/Transform/Transform"
import { produce } from "immer"

export function CycleOfFlatThirdsMap(){
    const activeRows:number[][][] = [
        [[0,1,2,3],[4,5,6,7]],
        [[9,10,11,12],[13,14,15,16]],
        [[19,20,21,22],[23,24,25,26]],
    ]
    const onKeyClick = (key:Key) => {

        const keyIndex:number = key.params.keyIndex
        const matchedRow:number[][]|undefined = activeRows.find((row:number[][])=>{
            return (row[0].includes(keyIndex) || row[1].includes(keyIndex))
        })
        if(matchedRow !== undefined){
            setMap(produce((draft:HexMap)=>{
                const mod:HexMapModifier = new HexMapModifier(draft)
                mod.keys_setDefault([All])
                mod.keys_setHilited(matchedRow[0])
                mod.keys_setSelected(matchedRow[1])
            })) 
        }
    }
    const getMap = () => {
        const params:HexMapBuilderParams = {rows:4, columns:9, tonic:Music.G, radius:37}
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.keys_setOpen([All], false)
        mod.keys_setVisible([18,8,17,27], false)
        mod.keys_setHilited(activeRows[0][0])
        mod.keys_setSelected(activeRows[0][1])
        //mod.keys_setPositionAsLabel([All])
        return map
    }
    const [map, setMap] = useState<HexMap>(getMap())
    const [width,height] = [650,600]
    return(
        <div>
            <svg width={width} height={height}>
                <g transform={TransformTranslate(width/2, height/2)}>
                    <HxMapGroup onKeyClick={onKeyClick} hexMap={map}/>
                </g>
            </svg>
        </div>
    )
}